import Link from 'next/link'
import React, { AnchorHTMLAttributes } from 'react'

interface Props {
	href: string
	passContext?: boolean
	passReferrer?: boolean
	passLinkJuice?: boolean
	openInNewWindow?: boolean
	preFetch?: boolean
	tag?: 'a' | 'Link'
	overrides?: AnchorHTMLAttributes<HTMLAnchorElement>
}

export const AffiliateLink: React.FC<React.PropsWithChildren<Props>> = ({
	href,
	children,
	tag = 'Link',
	preFetch = false,
	passContext = false,
	passLinkJuice = false,
	passReferrer = false,
	openInNewWindow = false,
	overrides = {}
}) => {
	const attributes = [!passReferrer && 'noreferrer', !passLinkJuice && 'nofollow', !passContext && 'noopener']
	const rel = attributes.filter(i => i).join(' ')
	if (openInNewWindow) overrides.target = '_blank'
	const aTag = (
		<a rel={rel} {...overrides}>
			{children}
		</a>
	)
	if (tag === 'a') {
		aTag.props.href = href
		return aTag
	} else {
		return (
			<Link href={href} prefetch={preFetch} passHref legacyBehavior>
				{aTag}
			</Link>
		)
	}
}
